
// // v1.2 fix text stuff, silly gemini2.5 cannot fix it, try free chatgpt like v3.0 (gotta login to upload img) -> too long for chatgpr, come back to gemini (open a new session, clean the old one) => nothing improved


// OK (draft 2 make it cleaner) v1.4 -> best so far, usin 101%
// still has these prob: cannot using the white part on iphone to swipe
// androi swipe become a bit annoying, gotta use its white part
// 
// 
// 

import React, { useState } from 'react';


// Define placeholder data - Add longDescription
const defaultCardData = {
  id: 1,
  bannerImageUrl: "https://cdn.theculturetrip.com/wp-content/uploads/2019/04/ia_0444_city-header_milan_marianna-tomaselli-768x432.jpg", // Larger placeholder
  bannerTag: 'NEW SEASON',
  bannerHeading: 'The Action Heroes need YOU!',
  bannerSubheading: 'Get ready for an action-packed Season!',
  // Add the longer description for the expanded view
  longDescription: 'The dastardly Minion General has his sights on world domination. Gear up, soldier! This is a job for the Action Heroes!',
  appIconUrl: "https://cdn.theculturetrip.com/wp-content/uploads/2019/04/ia_0378_hong-kong_jisu-choi_final_header-1-768x512.jpg",
  appName: 'Clash of Clans',
  appTagline: 'Lead Your Clan to Victory!',
  buttonText: 'Open',
  onButtonClick: () => { alert('Open button clicked!'); }, // Placeholder action
  // Add placeholder URLs/data for expanded view elements if needed
  topBarText: 'NOW AVAILABLE',
};

// Simple Icon Placeholders (replace with actual SVGs/Icons)
const IconPlaceholder = ({ children, style }) => (
  <div style={{ fontSize: '20px', color: 'white', ...style }}>{children}</div>
);
const CloseIcon = ({ onClick }) => (
    <button onClick={onClick} style={{ background: 'rgba(0,0,0,0.3)', border: 'none', color: 'white', borderRadius: '50%', width: '24px', height: '24px', fontSize: '14px', cursor: 'pointer', padding: 0, lineHeight: '24px' }}>✕</button>
);
const ShareIcon = () => (
    <IconPlaceholder style={{ fontSize: '18px', color: '#ccc' }}>🔗</IconPlaceholder> // Placeholder Share Icon
);


// Main Card Component - v1.2 Upward Expansion
function ExpandableCard({ cardData = defaultCardData }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  // --- Make card smaller ---
  const cardWidth = '300px'; // Reduced width
  const collapsedHeight = '250px'; // Reduced collapsed height
  const expandedMaxHeight = '60vh'; // Adjusted expanded height, ensure it fits viewport
  // --- End size changes ---

  const handleCardClick = () => {
    setIsExpanded(!isExpanded);
  };

  // Stop propagation when the button itself is clicked
  const handleButtonClick = (event) => {
    event.stopPropagation(); // Prevent card click handler from firing
    cardData.onButtonClick(); // Call original button action
  };

  const handleCloseClick = (event) => {
      event.stopPropagation(); // Prevent card click handler
      setIsExpanded(false);
  }

  const styles = {
    // Outer container for layout positioning (maintains space in the row)
    card: {
      position: 'relative', // Needed for absolute positioning of innerWrapper
      width: cardWidth,       // Use variable for width
      height: collapsedHeight, // Fixed height matching collapsed state
      cursor: isExpanded ? 'default' : 'pointer',
      margin: 0, // Margin is handled by the parent flex container
      // Remove visual styles like background, border, shadow, overflow - they move to innerWrapper
    },
    // Inner container for actual card content and animation
    innerWrapper: {
      position: 'absolute',
      bottom: 0, // Anchor to the bottom of the outer container
      left: 0,
      width: '100%',
      maxHeight: isExpanded ? expandedMaxHeight : collapsedHeight, // Animate maxHeight
      overflow: 'hidden', // Clip content during animation
      backgroundColor: '#ffffff',
      borderRadius: '15px',
      // Adjust shadow direction for upward expansion
      boxShadow: isExpanded ? '0 -6px 15px rgba(0, 0, 0, 0.2)' : '0 4px 12px rgba(0, 0, 0, 0.1)',
      border: isExpanded ? '1px solid #ddd' : 'none',
      transition: 'max-height 0.4s ease-in-out, box-shadow 0.4s ease-in-out',
      zIndex: isExpanded ? 10 : 1, // Bring to front when expanded
      display: 'flex', // Use flexbox for vertical layout
      flexDirection: 'column', // Stack children vertically
      fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
    },
    // Container for content (image + text sections) - allows infoSection to stick to bottom
    mainContentContainer: {
        flexGrow: 1, // Allow this container to take up available space
        overflowY: 'hidden', // <<< --- Disable vertical scrolling ---
        display: 'flex',
        flexDirection: 'column',
    },
    // Container for text sections (dark background when expanded)
    contentArea: {
       backgroundColor: isExpanded ? '#333' : 'transparent', // Only dark when expanded
       color: isExpanded ? 'white' : 'inherit',
       transition: 'background-color 0.4s ease-in-out',
       maxHeight: isExpanded ? '30vh' : 'none', // Limit height when expanded
       overflowY: isExpanded ? 'auto' : 'hidden', // Enable scrolling when expanded
       // padding handled by textSection now
    },
    imageSection: {
      position: 'relative', // Keep for overlay text positioning
      lineHeight: 0, // Prevent extra space below image
    },
    bannerImage: {
      width: '101%',
      display: 'block',
      // Removed borderBottom style
    },
    // --- Expanded Top Bar ---
    topBar: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        padding: '10px 15px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.2)', // Semi-transparent overlay on image
        zIndex: 5, // Above image
        color: 'white',
        fontSize: '0.8rem',
        fontWeight: 'bold',
        textTransform: 'uppercase'
    },
    // --- Text Area (Modified for expansion) ---
    textSection: {
       padding: '15px',
       position: 'relative', // For positioning share icon
       // If NOT using overlay on image, position absolutely when collapsed:
       // position: isExpanded ? 'relative' : 'absolute',
       // bottom: isExpanded ? 'auto' : '10px',
       // left: isExpanded ? 'auto' : '15px',
       // right: isExpanded ? 'auto' : '15px',
       // color: isExpanded ? 'inherit' : 'white', // Handled by contentArea now
       // textShadow: isExpanded ? 'none' : '0 1px 3px rgba(0, 0, 0, 0.6)',
       padding: '15px', // Always have padding
       position: 'relative', // For share icon positioning
    },
    bannerTag: {
      fontSize: '0.7rem',
      fontWeight: 'bold',
      textTransform: 'uppercase',
      marginBottom: '5px', // More space below tag
      letterSpacing: '0.5px',
      color: isExpanded ? '#aaa' : '#ccc' // Different color maybe
    },
    headingContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start', // Align items top
        marginBottom: '8px',
    },
    bannerHeading: {
      fontSize: '1.3rem',
      fontWeight: 'bold',
      margin: 0,
      lineHeight: '1.2',
      flexGrow: 1, // Allow heading to take space
      paddingRight: '10px', // Space before share icon
    },
    longDescription: {
        fontSize: '0.9rem',
        lineHeight: '1.4',
        color: '#eee', // Lighter text on dark bg
        marginTop: '10px', // Add space above description
    },
    // --- Bottom Info Section (Remains similar) ---
    infoSection: {
      display: 'flex',
      alignItems: 'center',
      padding: '15px',
      gap: '12px',
      borderTop: isExpanded ? '1px solid #555' : '1px solid #e0e0e0', // Separator line style changes
      backgroundColor: '#ffffff', // Always white background for this part
      // Removed duplicate borderTop and backgroundColor
      color: '#333', // Always dark text
      flexShrink: 0, // Prevent this section from shrinking
    },
    appIcon: {
      width: '50px', height: '50px', borderRadius: '10px', flexShrink: 0,
    },
    textInfo: { /* Style remains the same */
      flexGrow: 1, lineHeight: '1.3',
    },
    appName: {
      fontSize: '1rem', fontWeight: '600', color: '#333', margin: '0 0 2px 0',
    },
    appTagline: {
      fontSize: '0.85rem', color: '#666', margin: 0,
    },
    actionButton: {
        padding: '8px 20px', // Keep existing padding
        fontSize: '0.9rem',
        fontWeight: 'bold',
        color: '#007aff',
        backgroundColor: '#f0f0f0',
        border: 'none',
        borderRadius: '15px', // Pill shape
        cursor: 'pointer',
        flexShrink: 0,
        transition: 'background-color 0.2s ease',

        // --- Add these lines for centering text ---
        display: 'flex',
        alignItems: 'center',    // Vertically center content (the text)
        justifyContent: 'center', // Horizontally center content (the text)
        // --- End of added lines ---
      },
      actionButtonHover: {
          backgroundColor: '#e0e0e0'
      } // Keep hover style if you have it
  };

  return (
    // Outer container for layout
    <div style={styles.card} onClick={handleCardClick}>
      {/* Inner container for content and animation */}
      <div style={styles.innerWrapper}>

        {/* Conditionally render Top Bar when expanded */}
        {isExpanded && (
          <div style={styles.topBar}>
              <span>{cardData.topBarText}</span>
              <CloseIcon onClick={handleCloseClick} />
          </div>
        )}

        {/* Main Content Container (Image + Text Sections) */}
        <div style={styles.mainContentContainer}>
            {/* Image Section */}
            <div style={styles.imageSection}>
                <img
                src={cardData.bannerImageUrl}
                alt={cardData.bannerHeading}
                style={styles.bannerImage}
                />
                {/* Only show overlay text when NOT expanded */}
                {!isExpanded && (
                    <div style={{...styles.textSection, position: 'absolute', bottom: '10px', left: '15px', right: '15px', color: 'white', textShadow: '0 1px 3px rgba(0, 0, 0, 0.6)', padding: 0 }}>
                        <div style={styles.bannerTag}>{cardData.bannerTag}</div>
                        <h2 style={styles.bannerHeading}>{cardData.bannerHeading}</h2>
                        <p style={{...styles.bannerSubheading, margin: 0}}>{cardData.bannerSubheading}</p> {/* Added margin: 0 */}
                    </div>
                )}
            </div>

            {/* Content Area (Background changes on expand) */}
            <div style={styles.contentArea}>
                {/* Text Section (Visible when expanded, different styling) */}
                {isExpanded && (
                    <div style={styles.textSection}>
                        <div style={styles.bannerTag}>{cardData.bannerTag}</div>
                        <div style={styles.headingContainer}>
                            <h2 style={styles.bannerHeading}>{cardData.bannerHeading}</h2>
                            <ShareIcon />
                        </div>
                        {/* Conditionally render long description */}
                        <p style={styles.longDescription}>{cardData.longDescription}</p>
                    </div>
                )}
            </div>
        </div> {/* End Main Content Container */}

        {/* Bottom Info Section (Always Visible, outside main content for bottom sticking) */}
        <div style={styles.infoSection}>
            <img
                src={cardData.appIconUrl}
                alt={`${cardData.appName} icon`}
                style={styles.appIcon}
            />
            <div style={styles.textInfo}>
                <div style={styles.appName}>{cardData.appName}</div>
                <div style={styles.appTagline}>{cardData.appTagline}</div>
            </div>
            <button
                className="expanded-card-action-button"
                style={{
                    ...styles.actionButton,
                    ...(isHovered ? styles.actionButtonHover : {}),
                    // width: '70px !important', // Removed fixed width override
                }}
                onClick={handleButtonClick}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                {cardData.buttonText}
            </button>
        </div>
      </div> {/* End Inner Wrapper */}
    </div>
  );
}

export default ExpandableCard;



// (1/2 ok draft 1) clone v1.2 and fix the imge and button, only working version v1.3
// import { width } from '@fortawesome/free-solid-svg-icons/faSpinner';
// import React, { useState } from 'react';

// // Define placeholder data - Add longDescription

// const defaultCardData = {
//   id: 1,
//   bannerImageUrl: "https://cdn.theculturetrip.com/wp-content/uploads/2019/04/ia_0444_city-header_milan_marianna-tomaselli-768x432.jpg",
//   bannerTag: 'NEW SEASON',
//   bannerHeading: 'The Action Heroes need YOU!',
//   bannerSubheading: 'Get ready for an action-packed Season!',
//   longDescription: 'The dastardly Minion General has his sights on world domination. Gear up, soldier! This is a job for the Action Heroes!',
//   appIconUrl: "https://cdn.theculturetrip.com/wp-content/uploads/2019/04/ia_0378_hong-kong_jisu-choi_final_header-1-768x512.jpg",
//   appName: 'Clash of Clans',
//   appTagline: 'Lead Your Clan to Victory!',
//   buttonText: 'Open',
//   onButtonClick: () => { alert('Open button clicked!'); },
//   topBarText: 'NOW AVAILABLE',
// };

// const IconPlaceholder = ({ children, style }) => (
//   <div style={{ fontSize: '20px', color: 'white', ...style }}>{children}</div>
// );

// const CloseIcon = ({ onClick }) => (
//   <button onClick={onClick} style={{ background: 'rgba(0,0,0,0.3)', border: 'none', color: 'white', borderRadius: '50%', width: '24px', height: '24px', fontSize: '14px', cursor: 'pointer', padding: 0, lineHeight: '24px' }}>✕</button>
// );

// const ShareIcon = () => (
//   <IconPlaceholder style={{ fontSize: '18px', color: '#ccc' }}>🔗</IconPlaceholder> // Placeholder Share Icon
// );

// // Main Card Component - v1.2 Upward Expansion

// function ExpandableCard({ cardData = defaultCardData }) {
//   const [isExpanded, setIsExpanded] = useState(false);
//   const [isHovered, setIsHovered] = useState(false);
//   const [startTouch, setStartTouch] = useState(null);

//   const cardWidth = '300px';
//   const collapsedHeight = '250px';
//   const expandedMaxHeight = '60vh';

//   const handleCardClick = () => {
//     setIsExpanded(!isExpanded);
//   };

//   const handleButtonClick = (event) => {
//     event.stopPropagation();
//     cardData.onButtonClick();
//   };

//   const handleCloseClick = (event) => {
//     event.stopPropagation();
//     setIsExpanded(false);
//   };

//   // Handle touch events for swipe on mobile
//   const handleTouchStart = (event) => {
//     const touchStart = event.touches[0].clientY;
//     setStartTouch(touchStart);
//   };

//   const handleTouchMove = (event) => {
//     if (!startTouch) return;
//     const touchMove = event.touches[0].clientY;
//     if (startTouch - touchMove > 50) {
//       setIsExpanded(false);  // Close on swipe up
//     } else if (touchMove - startTouch > 50) {
//       setIsExpanded(true);  // Open on swipe down
//     }
//   };

//   const handleTouchEnd = () => {
//     setStartTouch(null); // Reset touch state
//   };

//   const styles = {
//     // card: {
//     //   position: 'relative',
//     //   width: cardWidth,
//     //   height: collapsedHeight,
//     //   cursor: isExpanded ? 'default' : 'pointer',
//     //   margin: 0,
//     //   touchAction: 'none',  // Important for swipe handling
//     // },
//     card: {
//       position: 'relative', // Needed for absolute positioning of innerWrapper
//       width: cardWidth,       // Use variable for width
//       height: collapsedHeight, // Fixed height matching collapsed state
//       cursor: isExpanded ? 'default' : 'pointer',
//       margin: 0, // Margin is handled by the parent flex container
//       // Remove visual styles like background, border, shadow, overflow - they move to innerWrapper
//     },
//     // innerWrapper: {
//     //   position: 'absolute',
//     //   bottom: 0,
//     //   left: 0,
//     //   width: '100%',
//     //   maxHeight: isExpanded ? expandedMaxHeight : collapsedHeight,
//     //   overflow: 'hidden',
//     //   backgroundColor: '#ffffff',
//     //   borderRadius: '15px',
//     //   boxShadow: isExpanded ? '0 -6px 15px rgba(0, 0, 0, 0.2)' : '0 4px 12px rgba(0, 0, 0, 0.1)',
//     //   border: isExpanded ? '1px solid #ddd' : 'none',
//     //   transition: 'max-height 0.4s ease-in-out, box-shadow 0.4s ease-in-out',
//     //   zIndex: isExpanded ? 10 : 1,
//     //   display: 'flex',
//     //   flexDirection: 'column',
//     //   fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
//     // },
//     innerWrapper: {
//       position: 'absolute',
//       bottom: 0, // Anchor to the bottom of the outer container
//       left: 0,
//       width: '100%',
//       maxHeight: isExpanded ? expandedMaxHeight : collapsedHeight, // Animate maxHeight
//       overflow: 'hidden', // Clip content during animation
//       backgroundColor: '#ffffff',
//       borderRadius: '15px',
//       // Adjust shadow direction for upward expansion
//       boxShadow: isExpanded ? '0 -6px 15px rgba(0, 0, 0, 0.2)' : '0 4px 12px rgba(0, 0, 0, 0.1)',
//       border: isExpanded ? '1px solid #ddd' : 'none',
//       transition: 'max-height 0.4s ease-in-out, box-shadow 0.4s ease-in-out',
//       zIndex: isExpanded ? 10 : 1, // Bring to front when expanded
//       display: 'flex', // Use flexbox for vertical layout
//       flexDirection: 'column', // Stack children vertically
//       fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
//     },    
//     // mainContentContainer: {
//     //   flexGrow: 1,
//     //   overflowY: 'hidden',
//     //   display: 'flex',
//     //   flexDirection: 'column',
//     // },
//     // contentArea: {
//     //   backgroundColor: isExpanded ? '#333' : 'transparent',
//     //   color: isExpanded ? 'white' : 'inherit',
//     //   transition: 'background-color 0.4s ease-in-out',
//     //   maxHeight: isExpanded ? '30vh' : 'none',
//     //   overflowY: isExpanded ? 'auto' : 'hidden',
//     // },


//     mainContentContainer: {
//         flexGrow: 1, // Allow this container to take up available space
//         overflowY: 'hidden', // <<< --- Disable vertical scrolling ---
//         display: 'flex',
//         flexDirection: 'column',
//     },
//     // Container for text sections (dark background when expanded)
//     contentArea: {
//        backgroundColor: isExpanded ? '#333' : 'transparent', // Only dark when expanded
//        color: isExpanded ? 'white' : 'inherit',
//        transition: 'background-color 0.4s ease-in-out',
//        maxHeight: isExpanded ? '30vh' : 'none', // Limit height when expanded
//        overflowY: isExpanded ? 'auto' : 'hidden', // Enable scrolling when expanded
//        // padding handled by textSection now
//     },    
    
//     imageSection: {
//       position: 'relative',
//       lineHeight: 0,
//       touchAction: 'pan-x',
//       width: '100%',
//       height: '180px', // Set a fixed height or an aspect ratio
//       backgroundImage: `url(${cardData.bannerImageUrl})`,
//       backgroundSize: 'cover',
//       backgroundPosition: 'center',
//     },

//     bannerImage: {
//       width: '101%',
//       display: 'block',
//       pointerEvents: 'none', // Pass touch events through the image
//       userSelect: 'none', // Prevent selection
//       WebkitUserDrag: 'none', // Prevent dragging
//       WebkitTouchCallout: 'none', // Disable long-press menu
//     },
//     // bannerImage: {
//     //   width: '100%',
//     //   // width: '101%',
//     //   display: 'block',
//     //   // Removed borderBottom style
//     //   // touchAction: 'none', // Disable default touch behaviors on the image
//     //   touchAction: 'pan-x',
//     //   userSelect: 'none', // Prevent text/image selection
//     //   WebkitUserDrag: 'none', // Disable dragging on iOS
//     //   WebkitTouchCallout: 'none', // Disable long-press menu on iOS      
//     // },    

//     textSection: {
//       padding: '15px',
//       position: 'relative',
//     },
//     bannerTag: {
//       fontSize: '0.7rem',
//       fontWeight: 'bold',
//       textTransform: 'uppercase',
//       marginBottom: '5px',
//       letterSpacing: '0.5px',
//       color: isExpanded ? '#aaa' : '#ccc',
//     },
//     bannerHeading: {
//       fontSize: '1.3rem',
//       fontWeight: 'bold',
//       margin: 0,
//       lineHeight: '1.2',
//       flexGrow: 1,
//       paddingRight: '10px',
//     },
//     longDescription: {
//       fontSize: '0.9rem',
//       lineHeight: '1.4',
//       color: '#eee',
//       marginTop: '10px',
//     },
//     infoSection: {
//       display: 'flex',
//       alignItems: 'center',
//       padding: '15px',
//       gap: '12px',
//       borderTop: isExpanded ? '1px solid #555' : '1px solid #e0e0e0',
//       backgroundColor: '#ffffff',
//       color: '#333',
//       flexShrink: 0,
//     },
//     appIcon: {
//       width: '50px',
//       height: '50px',
//       borderRadius: '10px',
//       flexShrink: 0,
//     },
//     appName: {
//       fontSize: '1rem',
//       fontWeight: '600',
//       color: '#333',
//       margin: '0 0 2px 0',
//     },
//     appTagline: {
//       fontSize: '0.85rem',
//       color: '#666',
//       margin: 0,
//     },
//     actionButton: {
//       padding: '8px 20px',
//       fontSize: '0.9rem',
//       fontWeight: 'bold',
//       color: '#007aff',
//       backgroundColor: '#f0f0f0',
//       border: 'none',
//       borderRadius: '15px',
//       cursor: 'pointer',
//       flexShrink: 0,
//       transition: 'background-color 0.2s ease',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//     },
//     actionButtonHover: {
//       backgroundColor: '#e0e0e0',
//     },
//   };


//   const original_styles = { // original style
//     // Outer container for layout positioning (maintains space in the row)
//     card: {
//       position: 'relative', // Needed for absolute positioning of innerWrapper
//       width: cardWidth,       // Use variable for width
//       height: collapsedHeight, // Fixed height matching collapsed state
//       cursor: isExpanded ? 'default' : 'pointer',
//       margin: 0, // Margin is handled by the parent flex container
//       // Remove visual styles like background, border, shadow, overflow - they move to innerWrapper
//     },
//     // Inner container for actual card content and animation
//     innerWrapper: {
//       position: 'absolute',
//       bottom: 0, // Anchor to the bottom of the outer container
//       left: 0,
//       width: '100%',
//       maxHeight: isExpanded ? expandedMaxHeight : collapsedHeight, // Animate maxHeight
//       overflow: 'hidden', // Clip content during animation
//       backgroundColor: '#ffffff',
//       borderRadius: '15px',
//       // Adjust shadow direction for upward expansion
//       boxShadow: isExpanded ? '0 -6px 15px rgba(0, 0, 0, 0.2)' : '0 4px 12px rgba(0, 0, 0, 0.1)',
//       border: isExpanded ? '1px solid #ddd' : 'none',
//       transition: 'max-height 0.4s ease-in-out, box-shadow 0.4s ease-in-out',
//       zIndex: isExpanded ? 10 : 1, // Bring to front when expanded
//       display: 'flex', // Use flexbox for vertical layout
//       flexDirection: 'column', // Stack children vertically
//       fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
//     },
//     // Container for content (image + text sections) - allows infoSection to stick to bottom
//     mainContentContainer: {
//         flexGrow: 1, // Allow this container to take up available space
//         overflowY: 'hidden', // <<< --- Disable vertical scrolling ---
//         display: 'flex',
//         flexDirection: 'column',
//     },
//     // Container for text sections (dark background when expanded)
//     contentArea: {
//        backgroundColor: isExpanded ? '#333' : 'transparent', // Only dark when expanded
//        color: isExpanded ? 'white' : 'inherit',
//        transition: 'background-color 0.4s ease-in-out',
//        maxHeight: isExpanded ? '30vh' : 'none', // Limit height when expanded
//        overflowY: isExpanded ? 'auto' : 'hidden', // Enable scrolling when expanded
//        // padding handled by textSection now
//     },
//     imageSection: {
//       position: 'relative', // Keep for overlay text positioning
//       lineHeight: 0, // Prevent extra space below image
//     },
//     bannerImage: {
//       width: '100%',
//       display: 'block',
//       // Removed borderBottom style
//     },
//     // --- Expanded Top Bar ---
//     topBar: {
//         position: 'absolute',
//         top: 0,
//         left: 0,
//         width: '100%',
//         padding: '10px 15px',
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         backgroundColor: 'rgba(0, 0, 0, 0.2)', // Semi-transparent overlay on image
//         zIndex: 5, // Above image
//         color: 'white',
//         fontSize: '0.8rem',
//         fontWeight: 'bold',
//         textTransform: 'uppercase'
//     },
//     // --- Text Area (Modified for expansion) ---
//     textSection: {
//        padding: '15px',
//        position: 'relative', // For positioning share icon
//        // If NOT using overlay on image, position absolutely when collapsed:
//        // position: isExpanded ? 'relative' : 'absolute',
//        // bottom: isExpanded ? 'auto' : '10px',
//        // left: isExpanded ? 'auto' : '15px',
//        // right: isExpanded ? 'auto' : '15px',
//        // color: isExpanded ? 'inherit' : 'white', // Handled by contentArea now
//        // textShadow: isExpanded ? 'none' : '0 1px 3px rgba(0, 0, 0, 0.6)',
//        padding: '15px', // Always have padding
//        position: 'relative', // For share icon positioning
//     },
//     bannerTag: {
//       fontSize: '0.7rem',
//       fontWeight: 'bold',
//       textTransform: 'uppercase',
//       marginBottom: '5px', // More space below tag
//       letterSpacing: '0.5px',
//       color: isExpanded ? '#aaa' : '#ccc' // Different color maybe
//     },
//     headingContainer: {
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'flex-start', // Align items top
//         marginBottom: '8px',
//     },
//     bannerHeading: {
//       fontSize: '1.3rem',
//       fontWeight: 'bold',
//       margin: 0,
//       lineHeight: '1.2',
//       flexGrow: 1, // Allow heading to take space
//       paddingRight: '10px', // Space before share icon
//     },
//     longDescription: {
//         fontSize: '0.9rem',
//         lineHeight: '1.4',
//         color: '#eee', // Lighter text on dark bg
//         marginTop: '10px', // Add space above description
//     },
//     // --- Bottom Info Section (Remains similar) ---
//     infoSection: {
//       display: 'flex',
//       alignItems: 'center',
//       padding: '15px',
//       gap: '12px',
//       borderTop: isExpanded ? '1px solid #555' : '1px solid #e0e0e0', // Separator line style changes
//       backgroundColor: '#ffffff', // Always white background for this part
//       // Removed duplicate borderTop and backgroundColor
//       color: '#333', // Always dark text
//       flexShrink: 0, // Prevent this section from shrinking
//     },
//     appIcon: {
//       width: '50px', height: '50px', borderRadius: '10px', flexShrink: 0,
//     },
//     textInfo: { /* Style remains the same */
//       flexGrow: 1, lineHeight: '1.3',
//     },
//     appName: {
//       fontSize: '1rem', fontWeight: '600', color: '#333', margin: '0 0 2px 0',
//     },
//     appTagline: {
//       fontSize: '0.85rem', color: '#666', margin: 0,
//     },
//     actionButton: {
//         padding: '8px 20px', // Keep existing padding
//         fontSize: '0.9rem',
//         fontWeight: 'bold',
//         color: '#007aff',
//         backgroundColor: '#f0f0f0',
//         border: 'none',
//         borderRadius: '15px', // Pill shape
//         cursor: 'pointer',
//         flexShrink: 0,
//         transition: 'background-color 0.2s ease',

//         // --- Add these lines for centering text ---
//         display: 'flex',
//         alignItems: 'center',    // Vertically center content (the text)
//         justifyContent: 'center', // Horizontally center content (the text)
//         // --- End of added lines ---
//       },
//       actionButtonHover: {
//           backgroundColor: '#e0e0e0'
//       } // Keep hover style if you have it
//   };


//   return (
//     <div
//       style={styles.card}
//       onClick={handleCardClick}
//       onTouchStart={handleTouchStart}
//       onTouchMove={handleTouchMove}
//       onTouchEnd={handleTouchEnd}
//     >
//       <div style={styles.innerWrapper}>
//         {isExpanded && (
//           <div style={styles.topBar}>
//             <span>{cardData.topBarText}</span>
//             <CloseIcon onClick={handleCloseClick} />
//           </div>
//         )}
//         <div style={styles.mainContentContainer}>
//           <div style={styles.imageSection}>
//             <img
//               src={cardData.bannerImageUrl}
//               alt={cardData.bannerHeading}
//               style={styles.bannerImage}
//             />
//             {/* <div
//               style={{
//                 ...styles.bannerImage,
//                 backgroundImage: `url(${cardData.bannerImageUrl})`,
//                 backgroundSize: 'cover',
//                 backgroundPosition: 'center',
//                 backgroundRepeat: 'no-repeat',
//               }}
//             /> */}


//             {!isExpanded && (
//               <div
//                 style={{
//                   ...styles.textSection,
//                   position: 'absolute',
//                   bottom: '10px',
//                   left: '15px',
//                   right: '15px',
//                   color: 'white',
//                   textShadow: '0 1px 3px rgba(0, 0, 0, 0.6)',
//                   padding: 0,
//                 }}
//               >
//                 <div style={styles.bannerTag}>{cardData.bannerTag}</div>
//                 <h2 style={styles.bannerHeading}>{cardData.bannerHeading}</h2>
//                 <p style={{ ...styles.bannerSubheading, margin: 0 }}>
//                   {cardData.bannerSubheading}
//                 </p>
//               </div>
//             )}
//           </div>
//           <div style={styles.contentArea}>
//             {isExpanded && (
//               <div style={styles.textSection}>
//                 <div style={styles.bannerTag}>{cardData.bannerTag}</div>
//                 <div style={styles.headingContainer}>
//                   <h2 style={styles.bannerHeading}>{cardData.bannerHeading}</h2>
//                   <ShareIcon />
//                 </div>
//                 <p style={styles.longDescription}>{cardData.longDescription}</p>
//               </div>
//             )}
//           </div>
//         </div>
//         <div style={styles.infoSection}>
//           <img
//             src={cardData.appIconUrl}
//             alt={`${cardData.appName} icon`}
//             style={styles.appIcon}
//           />
//           <div style={styles.textInfo}>
//             <div style={styles.appName}>{cardData.appName}</div>
//             <div style={styles.appTagline}>{cardData.appTagline}</div>
//           </div>
//           <button
//             className="expanded-card-action-button"
//             style={{
//               ...styles.actionButton,
//               ...(isHovered ? styles.actionButtonHover : {}),
//             }}
//             onClick={handleButtonClick}
//             onMouseEnter={() => setIsHovered(true)}
//             onMouseLeave={() => setIsHovered(false)}
//           >
//             {cardData.buttonText}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default ExpandableCard;









//1/2 ok (kind of work but not stable, the img in the card is not fit) v1.2 fix swipe on iphone
// import React, { useState } from 'react';

// // Define placeholder data - Add longDescription

// const defaultCardData = {
//   id: 1,
//   bannerImageUrl: "https://cdn.theculturetrip.com/wp-content/uploads/2019/04/ia_0444_city-header_milan_marianna-tomaselli-768x432.jpg",
//   bannerTag: 'NEW SEASON',
//   bannerHeading: 'The Action Heroes need YOU!',
//   bannerSubheading: 'Get ready for an action-packed Season!',
//   longDescription: 'The dastardly Minion General has his sights on world domination. Gear up, soldier! This is a job for the Action Heroes!',
//   appIconUrl: "https://cdn.theculturetrip.com/wp-content/uploads/2019/04/ia_0378_hong-kong_jisu-choi_final_header-1-768x512.jpg",
//   appName: 'Clash of Clans',
//   appTagline: 'Lead Your Clan to Victory!',
//   buttonText: 'Open',
//   onButtonClick: () => { alert('Open button clicked!'); },
//   topBarText: 'NOW AVAILABLE',
// };

// const IconPlaceholder = ({ children, style }) => (
//   <div style={{ fontSize: '20px', color: 'white', ...style }}>{children}</div>
// );

// const CloseIcon = ({ onClick }) => (
//   <button onClick={onClick} style={{ background: 'rgba(0,0,0,0.3)', border: 'none', color: 'white', borderRadius: '50%', width: '24px', height: '24px', fontSize: '14px', cursor: 'pointer', padding: 0, lineHeight: '24px' }}>✕</button>
// );

// const ShareIcon = () => (
//   <IconPlaceholder style={{ fontSize: '18px', color: '#ccc' }}>🔗</IconPlaceholder> // Placeholder Share Icon
// );

// // Main Card Component - v1.2 Upward Expansion

// function ExpandableCard({ cardData = defaultCardData }) {
//   const [isExpanded, setIsExpanded] = useState(false);
//   const [isHovered, setIsHovered] = useState(false);
//   const [startTouch, setStartTouch] = useState(null);

//   const cardWidth = '300px';
//   const collapsedHeight = '250px';
//   const expandedMaxHeight = '60vh';

//   const handleCardClick = () => {
//     setIsExpanded(!isExpanded);
//   };

//   const handleButtonClick = (event) => {
//     event.stopPropagation();
//     cardData.onButtonClick();
//   };

//   const handleCloseClick = (event) => {
//     event.stopPropagation();
//     setIsExpanded(false);
//   };

//   // Handle touch events for swipe on mobile
//   const handleTouchStart = (event) => {
//     const touchStart = event.touches[0].clientY;
//     setStartTouch(touchStart);
//   };

//   const handleTouchMove = (event) => {
//     if (!startTouch) return;
//     const touchMove = event.touches[0].clientY;
//     if (startTouch - touchMove > 50) {
//       setIsExpanded(false);  // Close on swipe up
//     } else if (touchMove - startTouch > 50) {
//       setIsExpanded(true);  // Open on swipe down
//     }
//   };

//   const handleTouchEnd = () => {
//     setStartTouch(null); // Reset touch state
//   };

//   const styles = {
//     card: {
//       position: 'relative',
//       width: cardWidth,
//       height: collapsedHeight,
//       cursor: isExpanded ? 'default' : 'pointer',
//       margin: 0,
//       touchAction: 'none',  // Important for swipe handling
//     },
//     innerWrapper: {
//       position: 'absolute',
//       bottom: 0,
//       left: 0,
//       width: '100%',
//       maxHeight: isExpanded ? expandedMaxHeight : collapsedHeight,
//       overflow: 'hidden',
//       backgroundColor: '#ffffff',
//       borderRadius: '15px',
//       boxShadow: isExpanded ? '0 -6px 15px rgba(0, 0, 0, 0.2)' : '0 4px 12px rgba(0, 0, 0, 0.1)',
//       border: isExpanded ? '1px solid #ddd' : 'none',
//       transition: 'max-height 0.4s ease-in-out, box-shadow 0.4s ease-in-out',
//       zIndex: isExpanded ? 10 : 1,
//       display: 'flex',
//       flexDirection: 'column',
//       fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
//     },
//     mainContentContainer: {
//       flexGrow: 1,
//       overflowY: 'hidden',
//       display: 'flex',
//       flexDirection: 'column',
//     },
//     contentArea: {
//       backgroundColor: isExpanded ? '#333' : 'transparent',
//       color: isExpanded ? 'white' : 'inherit',
//       transition: 'background-color 0.4s ease-in-out',
//       maxHeight: isExpanded ? '30vh' : 'none',
//       overflowY: isExpanded ? 'auto' : 'hidden',
//     },
//     textSection: {
//       padding: '15px',
//       position: 'relative',
//     },
//     bannerTag: {
//       fontSize: '0.7rem',
//       fontWeight: 'bold',
//       textTransform: 'uppercase',
//       marginBottom: '5px',
//       letterSpacing: '0.5px',
//       color: isExpanded ? '#aaa' : '#ccc',
//     },
//     bannerHeading: {
//       fontSize: '1.3rem',
//       fontWeight: 'bold',
//       margin: 0,
//       lineHeight: '1.2',
//       flexGrow: 1,
//       paddingRight: '10px',
//     },
//     longDescription: {
//       fontSize: '0.9rem',
//       lineHeight: '1.4',
//       color: '#eee',
//       marginTop: '10px',
//     },
//     infoSection: {
//       display: 'flex',
//       alignItems: 'center',
//       padding: '15px',
//       gap: '12px',
//       borderTop: isExpanded ? '1px solid #555' : '1px solid #e0e0e0',
//       backgroundColor: '#ffffff',
//       color: '#333',
//       flexShrink: 0,
//     },
//     appIcon: {
//       width: '50px',
//       height: '50px',
//       borderRadius: '10px',
//       flexShrink: 0,
//     },
//     appName: {
//       fontSize: '1rem',
//       fontWeight: '600',
//       color: '#333',
//       margin: '0 0 2px 0',
//     },
//     appTagline: {
//       fontSize: '0.85rem',
//       color: '#666',
//       margin: 0,
//     },
//     actionButton: {
//       padding: '8px 20px',
//       fontSize: '0.9rem',
//       fontWeight: 'bold',
//       color: '#007aff',
//       backgroundColor: '#f0f0f0',
//       border: 'none',
//       borderRadius: '15px',
//       cursor: 'pointer',
//       flexShrink: 0,
//       transition: 'background-color 0.2s ease',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//     },
//     actionButtonHover: {
//       backgroundColor: '#e0e0e0',
//     },
//   };

//   return (
//     <div
//       style={styles.card}
//       onClick={handleCardClick}
//       onTouchStart={handleTouchStart}
//       onTouchMove={handleTouchMove}
//       onTouchEnd={handleTouchEnd}
//     >
//       <div style={styles.innerWrapper}>
//         {isExpanded && (
//           <div style={styles.topBar}>
//             <span>{cardData.topBarText}</span>
//             <CloseIcon onClick={handleCloseClick} />
//           </div>
//         )}
//         <div style={styles.mainContentContainer}>
//           <div style={styles.imageSection}>
//             <img
//               src={cardData.bannerImageUrl}
//               alt={cardData.bannerHeading}
//               style={styles.bannerImage}
//             />
//             {!isExpanded && (
//               <div
//                 style={{
//                   ...styles.textSection,
//                   position: 'absolute',
//                   bottom: '10px',
//                   left: '15px',
//                   right: '15px',
//                   color: 'white',
//                   textShadow: '0 1px 3px rgba(0, 0, 0, 0.6)',
//                   padding: 0,
//                 }}
//               >
//                 <div style={styles.bannerTag}>{cardData.bannerTag}</div>
//                 <h2 style={styles.bannerHeading}>{cardData.bannerHeading}</h2>
//                 <p style={{ ...styles.bannerSubheading, margin: 0 }}>
//                   {cardData.bannerSubheading}
//                 </p>
//               </div>
//             )}
//           </div>
//           <div style={styles.contentArea}>
//             {isExpanded && (
//               <div style={styles.textSection}>
//                 <div style={styles.bannerTag}>{cardData.bannerTag}</div>
//                 <div style={styles.headingContainer}>
//                   <h2 style={styles.bannerHeading}>{cardData.bannerHeading}</h2>
//                   <ShareIcon />
//                 </div>
//                 <p style={styles.longDescription}>{cardData.longDescription}</p>
//               </div>
//             )}
//           </div>
//         </div>
//         <div style={styles.infoSection}>
//           <img
//             src={cardData.appIconUrl}
//             alt={`${cardData.appName} icon`}
//             style={styles.appIcon}
//           />
//           <div style={styles.textInfo}>
//             <div style={styles.appName}>{cardData.appName}</div>
//             <div style={styles.appTagline}>{cardData.appTagline}</div>
//           </div>
//           <button
//             className="expanded-card-action-button"
//             style={{
//               ...styles.actionButton,
//               ...(isHovered ? styles.actionButtonHover : {}),
//             }}
//             onClick={handleButtonClick}
//             onMouseEnter={() => setIsHovered(true)}
//             onMouseLeave={() => setIsHovered(false)}
//           >
//             {cardData.buttonText}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default ExpandableCard;




// ok fixed v1.1 ok but extended get cut off
// import React, { useState } from 'react';

// // Define placeholder data - Add longDescription
// const defaultCardData = {
//   id: 1,
//   bannerImageUrl: "https://cdn.theculturetrip.com/wp-content/uploads/2019/04/ia_0444_city-header_milan_marianna-tomaselli-768x432.jpg", // Larger placeholder
//   bannerTag: 'NEW SEASON',
//   bannerHeading: 'The Action Heroes need YOU!',
//   bannerSubheading: 'Get ready for an action-packed Season!',
//   // Add the longer description for the expanded view
//   longDescription: 'The dastardly Minion General has his sights on world domination. Gear up, soldier! This is a job for the Action Heroes!',
//   appIconUrl: "https://cdn.theculturetrip.com/wp-content/uploads/2019/04/ia_0378_hong-kong_jisu-choi_final_header-1-768x512.jpg",
//   appName: 'Clash of Clans',
//   appTagline: 'Lead Your Clan to Victory!',
//   buttonText: 'Open',
//   onButtonClick: () => { alert('Open button clicked!'); }, // Placeholder action
//   // Add placeholder URLs/data for expanded view elements if needed
//   topBarText: 'NOW AVAILABLE',
// };

// // Simple Icon Placeholders (replace with actual SVGs/Icons)
// const IconPlaceholder = ({ children, style }) => (
//   <div style={{ fontSize: '20px', color: 'white', ...style }}>{children}</div>
// );
// const CloseIcon = ({ onClick }) => (
//     <button onClick={onClick} style={{ background: 'rgba(0,0,0,0.3)', border: 'none', color: 'white', borderRadius: '50%', width: '24px', height: '24px', fontSize: '14px', cursor: 'pointer', padding: 0, lineHeight: '24px' }}>✕</button>
// );
// const ShareIcon = () => (
//     <IconPlaceholder style={{ fontSize: '18px', color: '#ccc' }}>🔗</IconPlaceholder> // Placeholder Share Icon
// );


// // Main Card Component - v1.2 Upward Expansion
// function ExpandableCard({ cardData = defaultCardData }) {
//   const [isExpanded, setIsExpanded] = useState(false);
//   const [isHovered, setIsHovered] = useState(false);
//   // --- Make card smaller ---
//   const cardWidth = '300px'; // Reduced width
//   const collapsedHeight = '250px'; // Reduced collapsed height
//   const expandedMaxHeight = '60vh'; // Adjusted expanded height, ensure it fits viewport
//   // --- End size changes ---

//   const handleCardClick = () => {
//     setIsExpanded(!isExpanded);
//   };

//   // Stop propagation when the button itself is clicked
//   const handleButtonClick = (event) => {
//     event.stopPropagation(); // Prevent card click handler from firing
//     cardData.onButtonClick(); // Call original button action
//   };

//   const handleCloseClick = (event) => {
//       event.stopPropagation(); // Prevent card click handler
//       setIsExpanded(false);
//   }

//   const styles = {
//     // Outer container for layout positioning (maintains space in the row)
//     card: {
//       position: 'relative', // Needed for absolute positioning of innerWrapper
//       width: cardWidth,       // Use variable for width
//       height: collapsedHeight, // Fixed height matching collapsed state
//       cursor: isExpanded ? 'default' : 'pointer',
//       margin: 0, // Margin is handled by the parent flex container
//       // Remove visual styles like background, border, shadow, overflow - they move to innerWrapper
//     },
//     // Inner container for actual card content and animation
//     innerWrapper: {
//       position: 'absolute',
//       bottom: 0, // Anchor to the bottom of the outer container
//       left: 0,
//       width: '100%',
//       maxHeight: isExpanded ? expandedMaxHeight : collapsedHeight, // Animate maxHeight
//       overflow: 'hidden', // Clip content during animation
//       backgroundColor: '#ffffff',
//       borderRadius: '15px',
//       // Adjust shadow direction for upward expansion
//       boxShadow: isExpanded ? '0 -6px 15px rgba(0, 0, 0, 0.2)' : '0 4px 12px rgba(0, 0, 0, 0.1)',
//       border: isExpanded ? '1px solid #ddd' : 'none',
//       transition: 'max-height 0.4s ease-in-out, box-shadow 0.4s ease-in-out',
//       zIndex: isExpanded ? 10 : 1, // Bring to front when expanded
//       display: 'flex', // Use flexbox for vertical layout
//       flexDirection: 'column', // Stack children vertically
//       fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
//     },
//     // Container for content (image + text sections) - allows infoSection to stick to bottom
//     mainContentContainer: {
//         flexGrow: 1, // Allow this container to take up available space
//         overflowY: 'hidden', // <<< --- Disable vertical scrolling ---
//         display: 'flex',
//         flexDirection: 'column',
//     },
//     // Container for text sections (dark background when expanded)
//     contentArea: {
//        backgroundColor: isExpanded ? '#333' : 'transparent', // Only dark when expanded
//        color: isExpanded ? 'white' : 'inherit',
//        transition: 'background-color 0.4s ease-in-out',
//        maxHeight: isExpanded ? '30vh' : 'none', // Limit height when expanded
//        overflowY: isExpanded ? 'auto' : 'hidden', // Enable scrolling when expanded
//        // padding handled by textSection now
//     },
//     imageSection: {
//       position: 'relative', // Keep for overlay text positioning
//       lineHeight: 0, // Prevent extra space below image
//     },
//     bannerImage: {
//       width: '100%',
//       display: 'block',
//       // Removed borderBottom style
//     },
//     // --- Expanded Top Bar ---
//     topBar: {
//         position: 'absolute',
//         top: 0,
//         left: 0,
//         width: '100%',
//         padding: '10px 15px',
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         backgroundColor: 'rgba(0, 0, 0, 0.2)', // Semi-transparent overlay on image
//         zIndex: 5, // Above image
//         color: 'white',
//         fontSize: '0.8rem',
//         fontWeight: 'bold',
//         textTransform: 'uppercase'
//     },
//     // --- Text Area (Modified for expansion) ---
//     textSection: {
//        padding: '15px',
//        position: 'relative', // For positioning share icon
//        // If NOT using overlay on image, position absolutely when collapsed:
//        // position: isExpanded ? 'relative' : 'absolute',
//        // bottom: isExpanded ? 'auto' : '10px',
//        // left: isExpanded ? 'auto' : '15px',
//        // right: isExpanded ? 'auto' : '15px',
//        // color: isExpanded ? 'inherit' : 'white', // Handled by contentArea now
//        // textShadow: isExpanded ? 'none' : '0 1px 3px rgba(0, 0, 0, 0.6)',
//        padding: '15px', // Always have padding
//        position: 'relative', // For share icon positioning
//     },
//     bannerTag: {
//       fontSize: '0.7rem',
//       fontWeight: 'bold',
//       textTransform: 'uppercase',
//       marginBottom: '5px', // More space below tag
//       letterSpacing: '0.5px',
//       color: isExpanded ? '#aaa' : '#ccc' // Different color maybe
//     },
//     headingContainer: {
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'flex-start', // Align items top
//         marginBottom: '8px',
//     },
//     bannerHeading: {
//       fontSize: '1.3rem',
//       fontWeight: 'bold',
//       margin: 0,
//       lineHeight: '1.2',
//       flexGrow: 1, // Allow heading to take space
//       paddingRight: '10px', // Space before share icon
//     },
//     longDescription: {
//         fontSize: '0.9rem',
//         lineHeight: '1.4',
//         color: '#eee', // Lighter text on dark bg
//         marginTop: '10px', // Add space above description
//     },
//     // --- Bottom Info Section (Remains similar) ---
//     infoSection: {
//       display: 'flex',
//       alignItems: 'center',
//       padding: '15px',
//       gap: '12px',
//       borderTop: isExpanded ? '1px solid #555' : '1px solid #e0e0e0', // Separator line style changes
//       backgroundColor: '#ffffff', // Always white background for this part
//       // Removed duplicate borderTop and backgroundColor
//       color: '#333', // Always dark text
//       flexShrink: 0, // Prevent this section from shrinking
//     },
//     appIcon: {
//       width: '50px', height: '50px', borderRadius: '10px', flexShrink: 0,
//     },
//     textInfo: { /* Style remains the same */
//       flexGrow: 1, lineHeight: '1.3',
//     },
//     appName: {
//       fontSize: '1rem', fontWeight: '600', color: '#333', margin: '0 0 2px 0',
//     },
//     appTagline: {
//       fontSize: '0.85rem', color: '#666', margin: 0,
//     },
//     actionButton: {
//         padding: '8px 20px', // Keep existing padding
//         fontSize: '0.9rem',
//         fontWeight: 'bold',
//         color: '#007aff',
//         backgroundColor: '#f0f0f0',
//         border: 'none',
//         borderRadius: '15px', // Pill shape
//         cursor: 'pointer',
//         flexShrink: 0,
//         transition: 'background-color 0.2s ease',

//         // --- Add these lines for centering text ---
//         display: 'flex',
//         alignItems: 'center',    // Vertically center content (the text)
//         justifyContent: 'center', // Horizontally center content (the text)
//         // --- End of added lines ---
//       },
//       actionButtonHover: {
//           backgroundColor: '#e0e0e0'
//       } // Keep hover style if you have it
//   };

//   return (
//     // Outer container for layout
//     <div style={styles.card} onClick={handleCardClick}>
//       {/* Inner container for content and animation */}
//       <div style={styles.innerWrapper}>

//         {/* Conditionally render Top Bar when expanded */}
//         {isExpanded && (
//           <div style={styles.topBar}>
//               <span>{cardData.topBarText}</span>
//               <CloseIcon onClick={handleCloseClick} />
//           </div>
//         )}

//         {/* Main Content Container (Image + Text Sections) */}
//         <div style={styles.mainContentContainer}>
//             {/* Image Section */}
//             <div style={styles.imageSection}>
//                 <img
//                 src={cardData.bannerImageUrl}
//                 alt={cardData.bannerHeading}
//                 style={styles.bannerImage}
//                 />
//                 {/* Only show overlay text when NOT expanded */}
//                 {!isExpanded && (
//                     <div style={{...styles.textSection, position: 'absolute', bottom: '10px', left: '15px', right: '15px', color: 'white', textShadow: '0 1px 3px rgba(0, 0, 0, 0.6)', padding: 0 }}>
//                         <div style={styles.bannerTag}>{cardData.bannerTag}</div>
//                         <h2 style={styles.bannerHeading}>{cardData.bannerHeading}</h2>
//                         <p style={{...styles.bannerSubheading, margin: 0}}>{cardData.bannerSubheading}</p> {/* Added margin: 0 */}
//                     </div>
//                 )}
//             </div>

//             {/* Content Area (Background changes on expand) */}
//             <div style={styles.contentArea}>
//                 {/* Text Section (Visible when expanded, different styling) */}
//                 {isExpanded && (
//                     <div style={styles.textSection}>
//                         <div style={styles.bannerTag}>{cardData.bannerTag}</div>
//                         <div style={styles.headingContainer}>
//                             <h2 style={styles.bannerHeading}>{cardData.bannerHeading}</h2>
//                             <ShareIcon />
//                         </div>
//                         {/* Conditionally render long description */}
//                         <p style={styles.longDescription}>{cardData.longDescription}</p>
//                     </div>
//                 )}
//             </div>
//         </div> {/* End Main Content Container */}

//         {/* Bottom Info Section (Always Visible, outside main content for bottom sticking) */}
//         <div style={styles.infoSection}>
//             <img
//                 src={cardData.appIconUrl}
//                 alt={`${cardData.appName} icon`}
//                 style={styles.appIcon}
//             />
//             <div style={styles.textInfo}>
//                 <div style={styles.appName}>{cardData.appName}</div>
//                 <div style={styles.appTagline}>{cardData.appTagline}</div>
//             </div>
//             <button
//                 className="expanded-card-action-button"
//                 style={{
//                     ...styles.actionButton,
//                     ...(isHovered ? styles.actionButtonHover : {}),
//                     // width: '70px !important', // Removed fixed width override
//                 }}
//                 onClick={handleButtonClick}
//                 onMouseEnter={() => setIsHovered(true)}
//                 onMouseLeave={() => setIsHovered(false)}
//             >
//                 {cardData.buttonText}
//             </button>
//         </div>
//       </div> {/* End Inner Wrapper */}
//     </div>
//   );
// }

// export default ExpandableCard;


// // v1.0 need to scroll to view card

// import React, { useState } from 'react';

// // Define placeholder data - Add longDescription
// const defaultCardData = {
//   id: 1,
//   bannerImageUrl: "https://cdn.theculturetrip.com/wp-content/uploads/2019/04/ia_0444_city-header_milan_marianna-tomaselli-768x432.jpg", // Larger placeholder
//   bannerTag: 'NEW SEASON',
//   bannerHeading: 'The Action Heroes need YOU!',
//   bannerSubheading: 'Get ready for an action-packed Season!',
//   // Add the longer description for the expanded view
//   longDescription: 'The dastardly Minion General has his sights on world domination. Gear up, soldier! This is a job for the Action Heroes!',
//   appIconUrl: "https://cdn.theculturetrip.com/wp-content/uploads/2019/04/ia_0378_hong-kong_jisu-choi_final_header-1-768x512.jpg",
//   appName: 'Clash of Clans',
//   appTagline: 'Lead Your Clan to Victory!',
//   buttonText: 'Open',
//   onButtonClick: () => { alert('Open button clicked!'); }, // Placeholder action
//   // Add placeholder URLs/data for expanded view elements if needed
//   topBarText: 'NOW AVAILABLE',
// };

// // Simple Icon Placeholders (replace with actual SVGs/Icons)
// const IconPlaceholder = ({ children, style }) => (
//   <div style={{ fontSize: '20px', color: 'white', ...style }}>{children}</div>
// );
// const CloseIcon = ({ onClick }) => (
//     <button onClick={onClick} style={{ background: 'rgba(0,0,0,0.3)', border: 'none', color: 'white', borderRadius: '50%', width: '24px', height: '24px', fontSize: '14px', cursor: 'pointer', padding: 0, lineHeight: '24px' }}>✕</button>
// );
// const ShareIcon = () => (
//     <IconPlaceholder style={{ fontSize: '18px', color: '#ccc' }}>🔗</IconPlaceholder> // Placeholder Share Icon
// );


// // Main Card Component
// function ExpandableCard({ cardData = defaultCardData }) {
//   const [isExpanded, setIsExpanded] = useState(false);
//   const [isHovered, setIsHovered] = useState(false);

//   const handleCardClick = () => {
//     setIsExpanded(!isExpanded);
//   };

//   // Stop propagation when the button itself is clicked
//   const handleButtonClick = (event) => {
//     event.stopPropagation(); // Prevent card click handler from firing
//     cardData.onButtonClick(); // Call original button action
//   };

//   const handleCloseClick = (event) => {
//       event.stopPropagation(); // Prevent card click handler
//       setIsExpanded(false);
//   }

//   const styles = {
//     // Base styles for the card container
//     card: {
//       maxWidth: '380px',
//       backgroundColor: '#ffffff', // Applies to bottom section mainly
//       borderRadius: '15px',
//       boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
//       overflow: 'hidden',
//       fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
//       margin: '20px auto',
//       position: 'relative', // Keep relative for positioning context
//       // --- Dynamic Styles for Expansion ---
//       maxHeight: isExpanded ? '80vh' : '320px', // Control expansion height (adjust max as needed)
//       height: isExpanded ? 'auto' : 'auto', // Allow height to adjust or set fixed initial height
//       cursor: isExpanded ? 'default' : 'pointer', // Change cursor only when not expanded
//       transition: 'max-height 0.4s ease-in-out', // Animate max-height
//       border: isExpanded ? '1px solid #ddd' : 'none', // Add border when expanded maybe
//       // If it should overlay content, might need position: fixed/absolute & zIndex based on parent
//     },
//     // Container for content below image (for background)
//     contentArea: {
//        backgroundColor: isExpanded ? '#333' : '#ffffff', // Darker background when expanded
//        color: isExpanded ? 'white' : 'inherit', // Adjust text color for dark bg
//        transition: 'background-color 0.4s ease-in-out',
//     },
//     imageSection: {
//       position: 'relative',
//       lineHeight: 0,
//     },
//     bannerImage: {
//       width: '100%',
//       display: 'block',
//        // No borderBottom here, let contentArea handle separation
//     },
//     // --- Expanded Top Bar ---
//     topBar: {
//         position: 'absolute',
//         top: 0,
//         left: 0,
//         width: '100%',
//         padding: '10px 15px',
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         backgroundColor: 'rgba(0, 0, 0, 0.2)', // Semi-transparent overlay on image
//         zIndex: 5, // Above image
//         color: 'white',
//         fontSize: '0.8rem',
//         fontWeight: 'bold',
//         textTransform: 'uppercase'
//     },
//     // --- Text Area (Modified for expansion) ---
//     textSection: {
//        padding: '15px',
//        position: 'relative', // For positioning share icon
//        // If NOT using overlay on image, position absolutely when collapsed:
//        // position: isExpanded ? 'relative' : 'absolute',
//        // bottom: isExpanded ? 'auto' : '10px',
//        // left: isExpanded ? 'auto' : '15px',
//        // right: isExpanded ? 'auto' : '15px',
//        // color: isExpanded ? 'inherit' : 'white', // Handled by contentArea now
//        // textShadow: isExpanded ? 'none' : '0 1px 3px rgba(0, 0, 0, 0.6)',
//        // padding: isExpanded ? '15px' : '0', // Adjust padding
//     },
//     bannerTag: {
//       fontSize: '0.7rem',
//       fontWeight: 'bold',
//       textTransform: 'uppercase',
//       marginBottom: '5px', // More space below tag
//       letterSpacing: '0.5px',
//       color: isExpanded ? '#aaa' : '#ccc' // Different color maybe
//     },
//     headingContainer: {
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'flex-start', // Align items top
//         marginBottom: '8px',
//     },
//     bannerHeading: {
//       fontSize: '1.3rem',
//       fontWeight: 'bold',
//       margin: 0,
//       lineHeight: '1.2',
//       flexGrow: 1, // Allow heading to take space
//       paddingRight: '10px', // Space before share icon
//     },
//     longDescription: {
//         fontSize: '0.9rem',
//         lineHeight: '1.4',
//         color: '#eee', // Lighter text on dark bg
//         marginTop: '10px', // Add space above description
//     },
//     // --- Bottom Info Section (Remains similar) ---
//     infoSection: {
//       display: 'flex',
//       alignItems: 'center',
//       padding: '15px',
//       gap: '12px',
//       borderTop: isExpanded ? '1px solid #555' : '1px solid #e0e0e0', // Separator line style changes
//       backgroundColor: '#ffffff', // Always white background for this part
//       color: '#333', // Reset text color for this section
//     },
//     appIcon: { /* Style remains the same */
//       width: '50px', height: '50px', borderRadius: '10px', flexShrink: 0
//     },
//     textInfo: { /* Style remains the same */
//       flexGrow: 1, lineHeight: '1.3'
//     },
//     appName: { /* Style remains the same */
//       fontSize: '1rem', fontWeight: '600', color: '#333', margin: '0 0 2px 0'
//     },
//     appTagline: { /* Style remains the same */
//       fontSize: '0.85rem', color: '#666', margin: 0
//     },
//     actionButton: {
//         padding: '8px 20px', // Keep existing padding
//         fontSize: '0.9rem',
//         fontWeight: 'bold',
//         color: '#007aff',
//         backgroundColor: '#f0f0f0',
//         border: 'none',
//         borderRadius: '15px', // Pill shape
//         cursor: 'pointer',
//         flexShrink: 0,
//         transition: 'background-color 0.2s ease',

//         // --- Add these lines for centering text ---
//         display: 'flex',
//         alignItems: 'center',    // Vertically center content (the text)
//         justifyContent: 'center', // Horizontally center content (the text)
//         // --- End of added lines ---
//       },
//       actionButtonHover: {
//           backgroundColor: '#e0e0e0'
//       } // Keep hover style if you have it
//   };

//   return (
//     // Add onClick handler to the main card div
//     <div style={styles.card} onClick={handleCardClick}>

//       {/* Conditionally render Top Bar when expanded */}
//       {isExpanded && (
//         <div style={styles.topBar}>
//             <span>{cardData.topBarText}</span>
//             <CloseIcon onClick={handleCloseClick} />
//         </div>
//       )}

//       {/* Image Section */}
//       <div style={styles.imageSection}>
//         <img
//           src={cardData.bannerImageUrl}
//           alt={cardData.bannerHeading}
//           style={styles.bannerImage}
//         />
//         {/* Only show overlay text when NOT expanded */}
//         {!isExpanded && (
//             <div style={{...styles.textSection, position: 'absolute', bottom: '10px', left: '15px', right: '15px', color: 'white', textShadow: '0 1px 3px rgba(0, 0, 0, 0.6)', padding: 0 }}>
//                 <div style={styles.bannerTag}>{cardData.bannerTag}</div>
//                 <h2 style={styles.bannerHeading}>{cardData.bannerHeading}</h2>
//                 <p style={styles.bannerSubheading}>{cardData.bannerSubheading}</p>
//             </div>
//         )}
//       </div>

//       {/* Content Area (Background changes on expand) */}
//       <div style={styles.contentArea}>
//         {/* Text Section (Visible when expanded, different styling) */}
//         {isExpanded && (
//             <div style={styles.textSection}>
//                 <div style={styles.bannerTag}>{cardData.bannerTag}</div>
//                 <div style={styles.headingContainer}>
//                     <h2 style={styles.bannerHeading}>{cardData.bannerHeading}</h2>
//                     <ShareIcon />
//                 </div>
//                 {/* Conditionally render long description */}
//                 <p style={styles.longDescription}>{cardData.longDescription}</p>
//             </div>
//         )}

//         {/* Bottom Info Section (Always Visible) */}
//         <div style={styles.infoSection}>
//           <img
//             src={cardData.appIconUrl}
//             alt={`${cardData.appName} icon`}
//             style={styles.appIcon}
//           />
//           <div style={styles.textInfo}>
//             <div style={styles.appName}>{cardData.appName}</div>
//             <div style={styles.appTagline}>{cardData.appTagline}</div>
//           </div>
//             <button
//             className="expanded-card-action-button" // Assuming it has a class like this
//             style={{
//                 ...styles.actionButton, // Keep your existing button styles
//                 ...(isHovered ? styles.actionButtonHover : {}),
//                 width: '70px !important',        // <<< --- ADD THIS LINE ---

//             }}
//             onClick={handleButtonClick} // Use the propagation-stopping handler
//             onMouseEnter={() => setIsHovered(true)}
//             onMouseLeave={() => setIsHovered(false)}
//             >
//             {cardData.buttonText}
//             </button>
//         </div>
//       </div> {/* End Content Area */}
//     </div> // End Card
//   );
// }

// export default ExpandableCard;
